module.exports = __webpack_public_path__ + "img/futop.663a5ea7.jpg";